<template>
  <svg width="14px" height="14px" viewBox="0 0 48 48"
       xmlns="http://www.w3.org/2000/svg"
       stroke="currentColor" fill="none" stroke-width="3">
    <title>calendar-event-available</title>
    <g id="icons_Q2" data-name="icons Q2">
      <path d="M32.4,23.6a1.9,1.9,0,0,0-2.8,0L21,32.2l-3.6-3.6a2,2,0,0,0-3.1.2,2.2,2.2,0,0,0,.4,2.7l4.9,4.9a1.9,1.9,0,0,0,2.8,0l10-10A1.9,1.9,0,0,0,32.4,23.6Z"/>
      <path d="M44,8H35V4.1A2.1,2.1,0,0,0,33.3,2,2,2,0,0,0,31,4V8H17V4.1A2.1,2.1,0,0,0,15.3,2,2,2,0,0,0,13,4V8H4a2,2,0,0,0-2,2V42a2,2,0,0,0,2,2H44a2,2,0,0,0,2-2V10A2,2,0,0,0,44,8Z"/>
    </g>
  </svg>
</template>
